var _line, _g, _g2, _path, _path2, _path3, _circle, _path4, _line2, _path5, _rect, _rect2, _rect3, _polygon, _polygon2, _polygon3, _polygon4, _line3, _polyline, _polygon5, _polyline2, _polygon6, _polyline3, _line4, _line5, _path6, _path7, _path8, _circle2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _polyline4, _path46, _path47, _path48, _path49, _polygon7, _polygon8, _path50, _path51, _path52, _path53, _path54, _path55, _path56;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChilling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "freepik_stories-building-safety",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 25.44,
    x2: 476.82,
    y1: 464.1,
    y2: 464.1,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.45,73.4h56.21s5.4-16.18-4.31-22.11-9.71,2.16-17.26-1.08c-6.24-2.67-7.41-7.75-9.15-13.13-.2-.61-.41-1.23-.63-1.85A25.21,25.21,0,0,0,400,30.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.38,23.44C379.29,13.17,356,17,356,38.88c0,5.4-12.95,0-17.8,7s.54,11.33-5.93,13.49-7-3.24-15.11-2.7-7,8.09-9.71,10.25-2.69,1.08-8.63,1.62-7,4.85-7,4.85h75.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.84 67.5s2.94-9.08-4.27-15.76-14.7-2.94-16.83 0-2.14 8.55-5.61 9.08-2.68-5.82-10.13-4.27-4.54 9.08-8 10.68-3.47-4.27-8.28-2.4-4.54 5.34-4.54 5.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.47,49.35a13.53,13.53,0,0,0-13.68-1.19c-7.74,3.57-4.17,11-7.74,12.79s-5.35-.29-9.81,1.79-4.17,5.05-4.17,5.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.94,101.42A5.12,5.12,0,0,0,49,100.8c-3.14.21-2.72,3.15-3.77,4s-1,.42-3.36.63a2.86,2.86,0,0,0-2.73,1.88H94.35s1.36-4.07-.08-6.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.67,98.7c-3.78-2.3-3.78.84-6.71-.42-2.43-1-2.88-3-3.56-5.1-.08-.24-.16-.48-.25-.72-3.18-8.86-18-9.47-18,1.42,0,2.1-5,0-6.92,2.73s.21,4.4-2.31,5.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3,105a6.15,6.15,0,0,0-1.66-6.13c-2.8-2.6-5.71-1.14-6.54,0s-.83,3.32-2.19,3.53-1-2.28-3.94-1.66-1.77,3.53-3.12,4.16-1.35-1.67-3.22-.94-1.77,2.08-1.77,2.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.38,98a5.26,5.26,0,0,0-5.32-.46c-3,1.39-1.62,4.28-3,5s-2.08-.11-3.81.7-1.62,2-1.62,2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.68,45.52a5.12,5.12,0,0,0-2.91-.62c-3.14.21-2.72,3.15-3.77,4s-1.05.42-3.36.62a2.86,2.86,0,0,0-2.73,1.89h55.18s1.35-4.07-.08-6.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.41,42.8c-3.78-2.31-3.78.84-6.72-.42-2.42-1-2.88-3-3.55-5.1-.08-.24-.16-.48-.25-.72-3.19-8.86-18-9.48-18,1.42,0,2.09-5,0-6.93,2.72s.21,4.41-2.3,5.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,49.11A6.15,6.15,0,0,0,249.38,43c-2.8-2.6-5.71-1.15-6.54,0s-.84,3.32-2.19,3.53-1-2.29-3.94-1.66-1.77,3.53-3.12,4.15-1.35-1.66-3.22-.93-1.77,2.08-1.77,2.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.12,42.05a5.26,5.26,0,0,0-5.32-.46c-3,1.38-1.62,4.28-3,5s-2.08-.12-3.82.69-1.62,2-1.62,2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236.01,
    y: 81.07,
    width: 59.25,
    height: 320.21,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.77,
    y: 81.07,
    width: 50.02,
    height: 320.21,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.64,
    y: 84.51,
    width: 45.81,
    height: 15.84,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.84,
    x2: 288.84,
    y1: 86.72,
    y2: 98.23,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.64,
    x2: 295.64,
    y1: 86.72,
    y2: 98.23,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302.43,
    x2: 302.43,
    y1: 86.72,
    y2: 98.23,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.23,
    x2: 309.23,
    y1: 86.72,
    y2: 98.23,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.03,
    x2: 316.03,
    y1: 86.72,
    y2: 98.23,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.82,
    x2: 322.82,
    y1: 86.72,
    y2: 98.23,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.67,
    y: 84.51,
    width: 39.27,
    height: 15.84,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.98,
    x2: 243.98,
    y1: 86.72,
    y2: 98.23,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.81,
    x2: 249.81,
    y1: 86.72,
    y2: 98.23,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.63,
    x2: 255.63,
    y1: 86.72,
    y2: 98.23,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.46,
    x2: 261.46,
    y1: 86.72,
    y2: 98.23,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.29,
    x2: 267.29,
    y1: 86.72,
    y2: 98.23,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.11,
    x2: 273.11,
    y1: 86.72,
    y2: 98.23,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.57,
    y: 123.07,
    width: 108.11,
    height: 278.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.19,
    y: 133.71,
    width: 40.14,
    height: 256.94,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.91,
    y: 123.07,
    width: 108.11,
    height: 278.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.81,
    y: 133.71,
    width: 90.3,
    height: 256.94,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.99,
    y: 144.08,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.14,
    y: 144.08,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.28,
    y: 144.08,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.43,
    y: 144.08,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.99,
    y: 161.29,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.14,
    y: 161.29,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.28,
    y: 161.29,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.43,
    y: 161.29,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.99,
    y: 178.51,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.14,
    y: 178.51,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.28,
    y: 178.51,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.43,
    y: 178.51,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.99,
    y: 195.72,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.14,
    y: 195.72,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.28,
    y: 195.72,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.43,
    y: 195.72,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.99,
    y: 212.94,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.14,
    y: 212.94,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.28,
    y: 212.94,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.43,
    y: 212.94,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.99,
    y: 230.16,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.14,
    y: 230.16,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.28,
    y: 230.16,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.43,
    y: 230.16,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.99,
    y: 247.37,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.14,
    y: 247.37,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.28,
    y: 247.37,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.43,
    y: 247.37,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.99,
    y: 264.59,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.14,
    y: 264.59,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.28,
    y: 264.59,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.43,
    y: 264.59,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.99,
    y: 281.8,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.14,
    y: 281.8,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.28,
    y: 281.8,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.43,
    y: 281.8,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.99,
    y: 299.02,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.14,
    y: 299.02,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.28,
    y: 299.02,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.43,
    y: 299.02,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.99,
    y: 316.23,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.14,
    y: 316.23,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.28,
    y: 316.23,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.43,
    y: 316.23,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.99,
    y: 333.45,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.14,
    y: 333.45,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.28,
    y: 333.45,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.43,
    y: 333.45,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.99,
    y: 350.67,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.14,
    y: 350.67,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.28,
    y: 350.67,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.43,
    y: 350.67,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.99,
    y: 367.88,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.14,
    y: 367.88,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.28,
    y: 367.88,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.43,
    y: 367.88,
    width: 18.5,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.75,
    y: 144.08,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.84,
    y: 144.08,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 144.08,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 144.08,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.75,
    y: 161.29,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.84,
    y: 161.29,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 161.29,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 161.29,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.75,
    y: 178.51,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.84,
    y: 178.51,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 178.51,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 178.51,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.75,
    y: 195.72,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.84,
    y: 195.72,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 195.72,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 195.72,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.75,
    y: 212.94,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.84,
    y: 212.94,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 212.94,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 212.94,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.75,
    y: 230.16,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.84,
    y: 230.16,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 230.16,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 230.16,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.75,
    y: 247.37,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.84,
    y: 247.37,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 247.37,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 247.37,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.75,
    y: 264.59,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.84,
    y: 264.59,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 264.59,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 264.59,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.75,
    y: 281.8,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.84,
    y: 281.8,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 281.8,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 281.8,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.75,
    y: 299.02,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.84,
    y: 299.02,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 299.02,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 299.02,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.75,
    y: 316.23,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.84,
    y: 316.23,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 316.23,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 316.23,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.75,
    y: 333.45,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.84,
    y: 333.45,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 333.45,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 333.45,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.75,
    y: 350.67,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.84,
    y: 350.67,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 350.67,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 350.67,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.75,
    y: 367.88,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.84,
    y: 367.88,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.92,
    y: 367.88,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 367.88,
    width: 6.2,
    height: 9.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.09,
    y: 427.16,
    width: 265.86,
    height: 37.43,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.19,
    y: 439.52,
    width: 6.9,
    height: 25.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.46,
    y: 439.52,
    width: 6.9,
    height: 25.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.73,
    y: 439.52,
    width: 6.9,
    height: 25.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 439.52,
    width: 6.9,
    height: 25.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.28,
    y: 439.52,
    width: 6.9,
    height: 25.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.94,
    y: 439.52,
    width: 6.9,
    height: 25.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.7,
    y: 439.52,
    width: 6.9,
    height: 25.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.45,
    y: 439.52,
    width: 6.9,
    height: 25.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.41,
    y: 373.33,
    width: 181.69,
    height: 69.41,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.95,
    y: 373.33,
    width: 132.79,
    height: 69.41,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.71,
    y: 385.48,
    width: 121.26,
    height: 40.62,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.47,
    y: 385.54,
    width: 25.21,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.04,
    y: 385.54,
    width: 25.21,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.6,
    y: 385.54,
    width: 25.21,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.16,
    y: 385.54,
    width: 25.21,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.72,
    y: 385.54,
    width: 25.21,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.47,
    y: 410.45,
    width: 25.21,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.04,
    y: 410.45,
    width: 25.21,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.6,
    y: 410.45,
    width: 25.21,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.16,
    y: 410.45,
    width: 25.21,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.72,
    y: 410.45,
    width: 25.21,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.02,
    y: 385.54,
    width: 20.33,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.85,
    y: 385.54,
    width: 20.33,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.69,
    y: 385.54,
    width: 20.33,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.53,
    y: 385.54,
    width: 20.33,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.37,
    y: 385.54,
    width: 20.33,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.02,
    y: 410.45,
    width: 20.33,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.85,
    y: 410.45,
    width: 20.33,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.69,
    y: 410.45,
    width: 20.33,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.53,
    y: 410.45,
    width: 20.33,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.37,
    y: 410.45,
    width: 20.33,
    height: 15.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.84,
    y: 362.63,
    width: 106.84,
    height: 11.35,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.62,
    y: 362.63,
    width: 106.84,
    height: 11.35,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m457.51 69.81-56.75 56.75a13.23 13.23 0 1 1-18.71-18.72l56.74-56.75a13.24 13.24 0 0 1 18.72 18.72z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m391.12 128.4-31.57 31.6a7.72 7.72 0 0 1-10.92-10.92l31.57-31.56a7.72 7.72 0 0 1 10.92 10.91z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m267.1 154.51a61.51 61.51 0 1 0 87 0 61.51 61.51 0 0 0-87 0zm79.34 79.34a50.69 50.69 0 1 1 0-71.69 50.69 50.69 0 0 1 0 71.69z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 313.39,
    cy: 195.21,
    r: 50.69,
    fill: "#fff",
    opacity: 0.56
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m269.9 151.71a61.51 61.51 0 1 0 87 0 61.51 61.51 0 0 0-87 0zm79.34 79.34a50.69 50.69 0 1 1 0-71.69 50.69 50.69 0 0 1 0 71.69z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 152.41,
    x2: 152.41,
    y1: 128.22,
    y2: 94.11,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m149.57 81.68v5.79l-2.31 4a4.87 4.87 0 0 0 4.87 4.88h0a4.87 4.87 0 0 0 4.87-4.83v-4",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3px"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    transform: "translate(298.85 151.97) rotate(180)",
    x: 144.55,
    y: 70.56,
    width: 9.76,
    height: 10.84,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    transform: "translate(298.85 133.81) rotate(180)",
    x: 140.93,
    y: 56.02,
    width: 16.98,
    height: 21.77,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    transform: "translate(298.67 140.59) rotate(180)",
    x: 135.87,
    y: 66.95,
    width: 26.92,
    height: 6.68,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "149.42 66.95 153.28 66.95 158.73 73.13 158.16 73.64 155.32 73.64",
    fill: "#263238"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "160.68 66.95 162.79 69.34 162.79 73.64 162.72 73.64 156.83 66.95",
    fill: "#263238"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "142.01 66.95 145.87 66.95 151.32 73.13 150.75 73.64 147.91 73.64",
    fill: "#263238"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "135.87 68.39 135.87 66.95 138.46 66.95 143.91 73.13 143.34 73.64 140.5 73.64",
    fill: "#263238"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 149.81,
    x2: 149.81,
    y1: 55.64,
    y2: 42.54,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "15.42 42.21 156.61 42.21 156.61 34.36 121 19.28 15.42 19.28",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "121 42.21 121 19.28 97.47 42.21 97.47 19.28",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "85.6 30.86 73.96 42.21 73.96 19.28 97.5 42.21 97.5 19.28 85.6 30.86",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "73.99 42.21 73.99 19.28 50.46 42.21 50.46 19.28",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "39.3 31.31 50.49 42.21 50.49 19.28 26.95 42.21 26.95 19.28 39.3 31.31",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 151.8,
    x2: 65.61,
    y1: 111.58,
    y2: 176.64,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 151.8,
    x2: 237.99,
    y1: 111.58,
    y2: 176.64,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m236.61 175.68a195 195 0 0 1-77-43.76 10.8 10.8 0 0 0-14.83 0 194.89 194.89 0 0 1-77 43.76 10.8 10.8 0 0 0-7.66 11.26c2 23.31 14.07 88 84.91 149.83a10.82 10.82 0 0 0 14.23 0c70.84-61.8 82.91-126.52 84.91-149.83a10.78 10.78 0 0 0-7.56-11.26z",
    fill: "#E14449",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m220.36 185.37a160.82 160.82 0 0 1-60.83-34.57 10.79 10.79 0 0 0-14.56 0 161 161 0 0 1-60.83 34.57 10.82 10.82 0 0 0-7.64 11.43c2.06 20.37 12.91 71.56 68.58 120.77a10.83 10.83 0 0 0 14.33 0c55.68-49.21 66.52-100.4 68.59-120.77a10.85 10.85 0 0 0-7.64-11.43z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m220.36 185.37a163.14 163.14 0 0 1-50.76-26.13 10.8 10.8 0 0 0-17.35 8.6v131.49a10.8 10.8 0 0 0 18.41 7.67c45.93-45.8 55.42-91.3 57.34-110.21a10.85 10.85 0 0 0-7.64-11.42z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    transform: "translate(-116.61 175.58) rotate(-45)",
    cx: 153.64,
    cy: 228.55,
    r: 22.22,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3px"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.22,237.87a5,5,0,0,1-3.75-1.74l-9.75-11.38a5,5,0,0,1,7.58-6.5l6,7.07,20-22.32a5,5,0,1,1,7.43,6.66L159,236.21a5,5,0,0,1-3.71,1.66Z",
    fill: "#E14449"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m179.11 202.84a3.48 3.48 0 0 1 2.59 5.82l-23.84 26.55a3.49 3.49 0 0 1-2.6 1.16 3.51 3.51 0 0 1-2.61-1.22l-9.75-11.38a3.49 3.49 0 1 1 5.3-4.54l7.16 8.36 21.15-23.59a3.47 3.47 0 0 1 2.6-1.16m0-3a6.53 6.53 0 0 0-4.83 2.15l-18.9 21-4.94-5.76a6.49 6.49 0 1 0-9.86 8.45l9.76 11.37a6.47 6.47 0 0 0 4.85 2.27h0.07a6.49 6.49 0 0 0 4.83-2.15l23.84-26.55a6.49 6.49 0 0 0-4.82-10.83z",
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M399,454s-3.46,5.27-6.28,7.49-9.44,5.42-11.29,6.91-1,2.82-.39,3.46,9.15,1.11,13.79,1.12,13-2,13-2,3.7.59,4.63.12,1.54-1.52,1.68-3.16-.38-10.9-.38-10.9Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M408.92,468.53c-3.61.58-4.32,1.4-11.29,2.44-5.75.86-14.25-.2-17.35-.75a2.31,2.31,0,0,0,.74,1.62c.64.64,9.15,1.11,13.79,1.12s13-2,13-2,3.7.59,4.63.12a3.57,3.57,0,0,0,1.68-3.12A45.11,45.11,0,0,0,408.92,468.53Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m402 457.87s-4-1.78-6.69 1.22",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m397.43 456.36s3.07 2.41 2.66 5",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m399 460.65s-3.15-1.46-5.29 1",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m395.41 459.42s2.42 2 2.08 4.1",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M396.68,463.47s-2.91-1.37-7.49.25",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M393,462.22a2.05,2.05,0,0,1-.41,3.2",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M421.79,459s-1.71,6.12-2.33,7-4.69,6-4.72,7.79,1.27,3.17,4.51,3.91,8.3,1,12.31-.83,5.83-2.43,6.85-5.23.34-12.19.34-12.19S426.2,450.2,421.79,459Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m438.41 471.61a17.37 17.37 0 0 0 0.59-4.61 30.27 30.27 0 0 1-2.82 3.79c-2 2.19-5.39 4.62-11.9 5.1a12.94 12.94 0 0 1-9.32-2.86 3 3 0 0 0-0.17 0.77c0 1.83 1.27 3.17 4.51 3.91s8.3 1 12.31-0.83 5.78-2.47 6.8-5.27z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M430.62,456.92s-5.49-.27-7.21,3",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m424.61 457s4.71 1 5.44 3.24",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M429.53,460.92s-5.49-.26-7.21,3",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m423.52 461s4.71 1 5.43 3.24",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M428.43,464.92s-5.49-.26-7.21,3",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m422.43 465s4.7 1 5.43 3.24",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M389,338.86s2.11,31.81,3,40.74,3.1,29.52,3.28,30.07.73,7.83.73,7.83-.55,2.92.18,9.3,2.92,19.68,2.92,19.68-1.83.36-1.64,1.82.91,5.47.91,5.47,6.92,2.36,8.93,2.55,6,0,6,0,1.64-2.74,1.46-4.19a44.91,44.91,0,0,0-1.46-5.29l.91-10.75,1.46-43.91s5.65,42.82,6.56,45.91,1.82,8,1.82,8-1.82,1.46-1.82,2.37.36,7.29.36,7.29,3.65-2.92,7.11-2.37,9.11,4.56,9.11,4.56a37.23,37.23,0,0,1,1.1-5.47c.72-2.37-.73-8.38-1.1-10a14.74,14.74,0,0,1-.18-5.65c.36-1.64.55-6.74.73-8.38s-.18-42.46-.18-42.46l3.72-46.75-53-1.64Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M397.17,270.09s-6.79,12.69-8.56,16.33-3.83,7.75-3.83,7.75c-6.46-9.35-12.87-18.66-19.87-27.61l-1.56-1.82s-8.74-3.3-9.56-2.5-2.79,13.12-.87,15,10,3,10,3l1.53,1.59-.21.19s12.23,27.14,14.2,29,4.29,5.13,8.55,5.34c2.44.11,10.7-17.35,10.7-17.35Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m396.35 269.91-10.48 18.33 8.28 19.76 5.12-10.47s2.93-28.76 0.73-29a4.54 4.54 0 0 0-3.65 1.38z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m383.19 290.67s8.28 22.18 9.26 22.18 3.9-4.39 3.65-6.58-6.82-19.5-9-19.74-2.94 1.95-3.91 4.14z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M368.16,270.58s-2.92-5.06-3.24-7.12c-.51-3.2,3.16-5.19,1.47-5.95s-4.83,1.44-5.12,3.73a13.64,13.64,0,0,0,.17,4.33s-1.64,3-1.22,5.24,1.55,4.69,2.41,5",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m352.5 259.71a2.12 2.12 0 0 0-2.6 1.65 2 2 0 0 0 1.08 2.69c1 0.49 6.59 3.69 7.15 2.15s1.1-2.92-0.07-3.61-5.56-2.88-5.56-2.88z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m351.8 264.32a2.11 2.11 0 0 0-2.6 1.64 2 2 0 0 0 1.08 2.7c1 0.49 6.58 3.69 7.15 2.14s1.09-2.91-0.07-3.6-5.56-2.88-5.56-2.88z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m351.33 269.05a1.8 1.8 0 0 0-2.21 1.4 1.69 1.69 0 0 0 0.92 2.29c0.86 0.42 5.6 3.14 6.08 1.83s0.93-2.48-0.06-3.07-4.73-2.45-4.73-2.45z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m351.52 273.26a1.6 1.6 0 0 0-2 1.25 1.51 1.51 0 0 0 0.81 2c0.77 0.37 5 2.8 5.42 1.63s0.83-2.21 0-2.74-4.23-2.14-4.23-2.14z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M408.4,260.44s-11.26,5.16-12,7-4.53,39.1-6.72,54-1.25,18.86-1.25,18.86,2.34,4.85,25.34,4.06,31.12-4.22,31.44-6.25.62.54.62-.87,1.72-67.88,0-71.95-11.42-10.79-14.23-11.1S408.4,260.44,408.4,260.44Z",
    fill: "#E14449",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M389.66,323.69l0,.18c-.38,2.59-.65,4.92-.84,7.05a142.62,142.62,0,0,0,35.1,2.66c12-.73,18.66-1.17,22.05-1.39.05-2.05.1-4.43.15-7.06C438.1,326,406.8,328.71,389.66,323.69Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m427.36 291.51c0.52-2.9 3.12-17.06 6.49-26.13l5.49 3.63 5.46 0.14s-12.25-10.79-15.71-11.72a7.22 7.22 0 0 0-2.1 0c-6.88 1.69-18.59 5.47-18.59 5.47s-11.26 5.16-12 7a26.3 26.3 0 0 0-0.55 3.13l2.82-1.6-3.4 17.79c-0.55-0.13-1.09-0.27-1.61-0.42l-0.83 7.19a142.37 142.37 0 0 0 34.49 2.54c9.27-0.57 15.36-1 19.21-1.21v-6.95c-4.39 0.41-11.38 0.94-19.17 1.14zm-28.88-1.6 4.16-20.71c5.2-2.87 11.19-6 13.8-6.84a50.85 50.85 0 0 1 9.85-2l2.89 1.92c-0.33 0.85-6.5 16.84-8.14 29.24l0.84 0.07a133.47 133.47 0 0 1-23.4-1.68z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M397.88,336.16c.08,1.42.2,2.8.35,4.14",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m401.42 305.27c-1.62 9.45-3.87 16.74-3.66 27.77",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m404.18 291.18s-1.17 4.88-2.48 12.11",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M391.7,339.41s-9.65-1.46-10.2-.37,0,16,.91,16.95,7.11,2.19,8.93,1.09,2.91-1.82,3.28-2.73.36-12.39-.37-13.85A2.39,2.39,0,0,0,391.7,339.41Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M403.18,341.23s-1.45,14.76.91,15.67a25.38,25.38,0,0,0,8.2,1.1c.92-.19,4.2-.73,4.74-2.19s.55-12.94.18-14S404.09,339.77,403.18,341.23Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m426.14 342.87s0.73 16.58 1.1 17.31 7.29 5.29 8.56 5.1 11.48-1.27 12-3.28 1.82-18.22 0.73-20-3.47-2.55-5.65-2.73-14.88 1.6-14.88 1.6a2 2 0 0 0-1.86 2z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M413.09,256.3l-4.69,4.14-.16,4.78-3.75,23.46S426.7,259.74,427,259.27a37.71,37.71,0,0,1,4.54-2.66l-1.41-5.79-2.35.63Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "408.4 260.44 411.54 266.65 412.03 261.9 414.72 268.49 423.75 261.13",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M410,222.53s-2,3.87-2.13,4.43a20.7,20.7,0,0,0,0,2.27s-5.1,5.06-4.93,5.43,2.13,1,2.13,1-1.87,12.91-.78,13.21,8.94-.39,8.94-.39L412,261.9l16.76-9.67,1.9-8.91s5.41-4.89,5.9-7.78.15-3.51.15-3.51Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m436.74 232-17.13-6-0.08 1.3-1.71 6s5.2-2.41 6.17-2.7 2.2 3.11 0.88 4.83-5.08 3.69-5.08 3.69 3 4.4 6.74 5.27a13.82 13.82 0 0 0 3.89 0.34l0.27-1.34s5.41-4.89 5.9-7.78 0.15-3.61 0.15-3.61z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m409 226.81a2.65 2.65 0 0 1 3.23 1.13",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M410.14,230.09c-.13.74-.48,1.29-.78,1.24s-.46-.69-.33-1.43.48-1.29.78-1.23S410.26,229.36,410.14,230.09Z",
    fill: "#263238"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "404.1 248.62 416.97 248.15 413 251.91 413.14 248.52",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "426.25 231.94 430.42 244.66 433.82 242.37 429.86 232.22",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M408.23,219.5s-8-.32-7.08.17,39.13,19.83,39.13,19.83a26.52,26.52,0,0,1-.15-4c.17-1,2.86-7,3.32-13.55s-12.56-12.51-19.23-14.32-10.6.84-11.86,4.28A41.44,41.44,0,0,1,408.23,219.5Z",
    fill: "#E14449",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m418.85 224.8-6.68-3.8s5.74-8.7 5.8-9.86a19.13 19.13 0 0 1 0.22-2.16s0.46-1.83 6.61 0",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M404.49,236.45a8.19,8.19,0,0,1,4-.11c1.57.57,1.92,1.72,2.56,1.6s4.49-1,.44,1.71c-1.52,1-2.88.67-4.07.53a15.94,15.94,0,0,1-2.67-.64A2.25,2.25,0,0,1,404.49,236.45Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M434,337.7a12.7,12.7,0,0,1-3.38,2.61,1.44,1.44,0,0,1-.62,1.48",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M468.6,298.85c-3.38-8.44-8.76-15.91-13.27-23.8a44.59,44.59,0,0,0-4.79-7.4,12.09,12.09,0,0,0-7.46-4.34h-.15a7.55,7.55,0,0,0-5.88,2,8.7,8.7,0,0,0-2.58,5.63,23.81,23.81,0,0,0,2.66,14.76c2.56,4.64,6.54,8.22,10.26,12,1.09,1.11,2.15,2.23,3.15,3.41Q440.78,313.5,431,325.9a6.72,6.72,0,0,0-1,1.57h0l-.26,0-5.52,3.18s-4.08,2.77-4.15,4.15c-.15,2.93.94,4.15,1.83,5.56a21.8,21.8,0,0,0,3.65,3.13c.88.47,3,1.3,4.43.11s5.69-2.37,5.93-4.27-1.9-1.66-1.9-1.66a7,7,0,0,0,2.49-4.64,8.44,8.44,0,0,0,1.82-.6,23,23,0,0,0,5.1-3.58c7.23-6,15-11.42,22.34-17.3a11.91,11.91,0,0,0,3.57-3.88C470.62,305,469.74,301.68,468.6,298.85Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m468.6 298.85a28 28 0 0 0-11.82-3.55 18 18 0 0 0-9.39 2.4c-3.72-3.8-7.7-7.38-10.26-12a23.81 23.81 0 0 1-2.66-14.76 8.7 8.7 0 0 1 2.58-5.63 7.55 7.55 0 0 1 5.88-2h0.15a12.09 12.09 0 0 1 7.46 4.34 44.59 44.59 0 0 1 4.79 7.4c4.51 7.89 9.89 15.36 13.27 23.8z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m447.76 304.08s5.85-4.39 10.73-3.9 10.23 4.63 11 4.38 2.93-2.43 2.2-4.87a42.32 42.32 0 0 0-2.2-6.58c-1.22-2.68-6.33-4.14-11.21-2.92s-12.67 6.82-12.42 8.52a29.15 29.15 0 0 0 1.9 5.37z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChilling);
export default __webpack_public_path__ + "static/media/chilling.fb698a68e83e083bab0deae68bc1af07.svg";
export { ForwardRef as ReactComponent };